import Header from 'components/headers/wallet'
import useGetBankAccounts from './hooks/useGetBankAccounts'
import { useCallback, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import AddBankIcon from 'assets/images/bankAcoount/Add Card.svg'
import { toast } from 'react-toastify'
import CustomBottomSheet from 'components/bottomSheet'
import BottomSheetItems from './bottomSheet'
import { useNavigate } from 'react-router-dom'
interface IOpenBank {
    open: boolean
    item: IBankCardsResult | undefined
}
export default function BankCardsPage() {
    const [isOpen, setIsOpen] = useState<IOpenBank>({
        open: false,
        item: undefined,
    })
    const navigate = useNavigate()
    const { data, isLoading, fetchNextPage, refetch } = useGetBankAccounts()
    const onWatchEnd = useCallback(() => {
        fetchNextPage()
    }, [fetchNextPage])
    return (
        <div className=" h-full">
            <div className=" flex flex-col h-screen overflow-y-auto pb-14 ">
                <div className="grow-0">
                    <Header title="شماره حساب" />
                </div>
                <div className=" grow">
                    <InfiniteScroll
                        next={onWatchEnd}
                        hasMore={
                            data
                                ? data?.pages[data.pages.length - 1].next
                                    ? true
                                    : false
                                : false
                        }
                        dataLength={
                            data
                                ? data.pages.flatMap((x) => x.results).length
                                : 0
                        }
                        loader={<DotsLoading />}
                    >
                        <>
                            {!isLoading && data ? (
                                data.pages
                                    .flatMap((x) => x.results)
                                    .map((item) => (
                                        <Item
                                            item={item}
                                            key={item.id}
                                            setIsOpen={setIsOpen}
                                            isOpen={isOpen}
                                        />
                                    ))
                            ) : (
                                <DotsLoading />
                            )}
                        </>
                    </InfiniteScroll>
                </div>
            </div>
            <div className="w-[96%] right-[2%] fixed bottom-0 inset-x-0 ">
                <button
                    className=" border-1 text-green-1 border-green-1 my-1 items-center flex justify-center py-3 rounded-lg bg-white w-full"
                    onClick={() => navigate('add')}
                >
                    <img
                        src={AddBankIcon}
                        alt="add-bank-card"
                        className=" mx-1"
                    />
                    افزودن کارت جدید
                </button>
            </div>
            <CustomBottomSheet
                isOpen={isOpen.open}
                onDismiss={() => setIsOpen({ open: false, item: undefined })}
            >
                {isOpen.item && (
                    <BottomSheetItems
                        item={isOpen.item}
                        setIsOpen={setIsOpen}
                        refetch={refetch}
                    />
                )}
            </CustomBottomSheet>
        </div>
    )
}
